<!-- Управляет выбором ТС и единым запуском создания или продолжения акта. -->
<template>
  <VehicleInspectionSelectionModal
    :visible="selectionOpen"
    :initial-vehicle="initialVehicle"
    @close="selectionOpen = false"
    @start="startInspection"
  />

  <VehicleInspectionWizard
    v-if="selectedVehicle"
    :visible="wizardOpen"
    :vehicle="selectedVehicle"
    :waybill-id="waybillId"
    :draft-id="draftId"
    @close="closeWizard"
    @completed="handleCompleted"
  />
</template>

<script>
import VehicleInspectionSelectionModal from "@/components/Vehicle/Inspection/SelectionModal.vue";
import VehicleInspectionWizard from "@/components/Vehicle/Inspection/Wizard.vue";

export default {
  name: "VehicleInspectionLauncher",
  components: {
    VehicleInspectionSelectionModal,
    VehicleInspectionWizard,
  },
  props: {
    initialVehicle: {
      type: Object,
      default: null,
    },
  },
  emits: ["completed"],
  data() {
    return {
      selectionOpen: false,
      wizardOpen: false,
      selectedVehicle: null,
      waybillId: null,
      draftId: null,
    };
  },
  methods: {
    openSelection() {
      this.selectionOpen = true;
    },
    continueInspection(inspection) {
      const vehicle = this.initialVehicle || inspection.vehicle;
      if (!vehicle) return;

      this.openWizard({
        vehicle,
        waybillId: inspection.waybill_id,
        draftId: inspection.id,
      });
    },
    startInspection({ vehicle, waybillId }) {
      this.openWizard({ vehicle, waybillId });
    },
    openWizard({ vehicle, waybillId = null, draftId = null }) {
      this.selectedVehicle = vehicle;
      this.waybillId = waybillId || null;
      this.draftId = draftId;
      this.selectionOpen = false;
      this.wizardOpen = true;
    },
    closeWizard() {
      this.wizardOpen = false;
      this.selectedVehicle = null;
      this.waybillId = null;
      this.draftId = null;
    },
    handleCompleted(inspection) {
      this.$emit("completed", {
        inspection,
        vehicle: this.selectedVehicle,
      });
    },
  },
};
</script>
